export default () => {
  return {
    document: document.documentElement || document.body,
    progressWidth: 0,
    calcProgressBar() {
      this.progressWidth = `${this.document['scrollTop'] / (this.document['scrollHeight'] - this.document.clientHeight) * 100}vw`;
    },
  }
}
